<template>
  <div v-if="showWishlistButton" class="wishlist-product-button">
    <SfButton
      :aria-label="`${ariaLabel} ${title}`"
      class="sf-button--pure sf-product__wishlist-icon"
      :class="isInWishlist && 'on-wishlist'"
      data-testid="wishlist-product-button"
      @click="toggleIsInWishlist"
    >
      <div class="wishlist-product-icon">
        <FullWishlistProductIcon v-if="isInWishlist" />
        <EmptyWishlistProductIcon v-else />
      </div>
    </SfButton>
    <span class="wishlist-product-button__label" v-if="label !== ''">{{
      $t(label)
    }}</span>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { SfButton } from '@storefront-ui/vue';
import {
  FullWishlistProductIcon,
  EmptyWishlistProductIcon,
} from '~/components/General/Icons';

export default defineComponent({
  name: 'WishlistButton',
  components: { SfButton, FullWishlistProductIcon, EmptyWishlistProductIcon },
  props: {
    isInWishlist: {
      type: Boolean,
      default: false,
    },
    showWishlistButton: {
      type: Boolean,
      default: true,
    },
    wishlistIcon: {
      type: [String, Array, Boolean],
      default: 'heart',
    },
    isInWishlistIcon: {
      type: [String, Array],
      default: 'heart_fill',
    },
    title: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const toggleIsInWishlist = () => {
      emit('clickWishlist', !props.isInWishlist);
    };
    const ariaLabel = () =>
      props.isInWishlist ? 'Remove from wishlist' : 'Add to wishlist';

    return { toggleIsInWishlist, ariaLabel };
  },
});
</script>

<style lang="scss" scoped>
.wishlist-product-button {
  display: flex;
  align-items: center;
  text-align: center;
  gap: 0.625rem;
  &__label {
    font-size: 13px;
    color: #676262;
  }
}
</style>
